export const getOrThrow = <T>(value: T | null | undefined, error: string): T => {
  if (value === undefined || value === null) {
    throw new Error(error);
  }
  return value;
};
